const ENABLE_HTTPS: boolean = true;
const DOMAIN = window.location.hostname;

export const DocsUrl: string = `http${ENABLE_HTTPS ? "s" : ""}://docs.${DOMAIN}`;

const SERVER_PORT = 80;
export const HTTP_SERVER_ORIGIN: string = `http${ENABLE_HTTPS ? "s" : ""}://${DOMAIN}`;

export const ACCESS_TOKEN_STORAGE_NAME = "access";
export const REFRESH_TOKEN_STORAGE_NAME = "refresh";
